import PublicLayout from "sections/PublicLayout";
import TeacherDirectory from "sections/public/TeacherDirectory";
import { getSchoolTeachers } from "firestoreService";

function SchoolTeacher() {
  return (
    <PublicLayout
      eyebrow="A1 Play School"
      title="Play School Teachers"
      subtitle="The team looking after our youngest learners."
    >
      <TeacherDirectory fetchTeachers={getSchoolTeachers} />
    </PublicLayout>
  );
}

export default SchoolTeacher;
